import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const root = css`
  block-size: ${spacing(4.75)};
`

export const lead = css`
  inline-size: ${spacing(5)};
  display: flex;
  align-items: center;
`

export const tail = css`
  margin-inline-start: auto;
`

export const paper = css`
  & > * {
    padding: 8px;
  }
`
